import { render, staticRenderFns } from "./FudaoTeacherInviteSessionDialog.vue?vue&type=template&id=f78d313c&"
import script from "./FudaoTeacherInviteSessionDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoTeacherInviteSessionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports